// extracted by mini-css-extract-plugin
module.exports = {"product":"J_cY","product__image":"J_cZ","product__featured":"J_c0","product__prices":"J_cG","product__prices__sale":"J_c1","product__title":"J_cB","product__title__sale":"J_c2"};